module.exports = __webpack_public_path__ + "static/media/coin.ae2d581b.svg";